import axios from "axios";

import { Auth_URL, UserService_URL, Auth_OTP_URL, ConsentManagementService_URL } from "../Url";
import HashMap from "hashmap";
// import { ADDITIONAL_PROPERTY_FLAG } from "react-jsonschema-form/lib/utils";

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const dashboardViewActions = {
  VIEW_DASHBOARD_STATUS_TRUE: "VIEW_DASHBOARD_STATUS_TRUE",
  VIEW_DASHBOARD_STATUS_FALSE: "VIEW_DASHBOARD_STATUS_FALSE",
};

export function setDashboardView(props) {
  if (props) {
    return (dispatch) => dispatch(viewDashboardStatusTrue(props));
  } else {
    return (dispatch) => dispatch(viewDashboardStatusFalse(props));
  }
}

export function viewDashboardStatusTrue() {
  return {
    type: dashboardViewActions.VIEW_DASHBOARD_STATUS_TRUE,
  };
}

export function viewDashboardStatusFalse() {
  return {
    type: dashboardViewActions.VIEW_DASHBOARD_STATUS_FALSE,
  };
}

const actions = {
  CHECK_AUTHORIZATION: "CHECK_AUTHORIZATION",
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGOUT_POPUP: "LOGOUT_POPUP",
  LOGOUT: "LOGOUT",
  LOGOUT_FLAG_UPDATE: "LOGOUT_FLAG_UPDATE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  SET_ERROR: "SET_ERROR",
  LOGIN_ERROR: "LOGIN_ERROR",
  SEND_OTP_REQUEST: "SEND_OTP_REQUEST",
  SEND_OTP_SUCCESS: "SEND_OTP_SUCCESS",
  SEND_OTP_ERROR: "SEND_OTP_ERROR",

  VERIFY_OTP_REQUEST: "SEND_OTP_REQUEST",
  VERIFY_OTP_SUCCESS: "SEND_OTP_SUCCESS",
  VERIFY_OTP_ERROR: "SEND_OTP_ERROR",

  loginRequest: () => ({ type: actions.LOGIN_REQUEST, isPosting: true }),
  sendOTPRequest: () => ({ type: actions.SEND_OTP_REQUEST, isPosting: true }),
  sendOTPSuccess: (props) => (dispatch) => {
    dispatch({
      type: actions.SEND_OTP_SUCCESS,
      payload: props,
    });
  },
  sendOTPError: (error) => ({ type: actions.SEND_OTP_ERROR, payload: error }),
  loginError: (error) => ({ type: actions.LOGIN_ERROR, payload: error }),
  loginSuccess: (props, token, nameAlias, dpInfo) => (dispatch) => {
    dispatch({
      type: actions.LOGIN_SUCCESS,
      payload: props,
      token: token,
      nameAlias: nameAlias,
      dpInfo: dpInfo,
    });
  },

  verifyOTPRequest: () => ({
    type: actions.VERIFY_OTP_REQUEST,
    isPosting: true,
  }),
  verifyOTPSuccess: (props) => (dispatch) => {
    dispatch({
      type: actions.VERIFY_OTP_SUCCESS,
      payload: props,
    });
  },
  verifyOTPError: (error) => ({
    type: actions.VERIFY_OTP_ERROR,
    payload: error,
  }),

  sendOTP: (props) => (dispatch) =>
    axios({
      method: "post",
      // If a mobileNo is supplied, send the body keyed as { mobileNo: ... };
      // otherwise keep the existing { emailId: ... } shape used by the login,
      // forgot-password and reset-password flows.
      data: props.mobileNo
        ? { mobileNo: props.mobileNo }
        : { emailId: props.emailID },
      headers: {
        "Content-Type": "application/json",
      },
      url: `${Auth_OTP_URL}/Apc_Persist/Amc_49/sendEmailOtpForExternalUserV2`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          // const token = response.data.data.access_token;
          // const userId = response.data.userdto.userId;
          dispatch(actions.sendOTPSuccess(response));
          return response;
        } else if (response.status === 403) {
          const error = new Error(response.statusText);
          dispatch(actions.sendOTPError(error));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(actions.sendOTPError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.sendOTPError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.sendOTPError(err));
              break;
            case 401:
              dispatch(actions.sendOTPError("Unauthorized"));
              break;
            case 500:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.sendOTPError(err));
              break;
            default:
              dispatch(actions.sendOTPError("Unknown Error"));
              return err;
            // break;
          }
        } else {
          dispatch(actions.sendOTPError("Internal Server Error"));
        }
      }),

  verifyOTP: (props) => (dispatch) =>
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${Auth_OTP_URL}/verifyOTP?mobileNo=${props.emailID}&otp=${props.otp}&transactionId=27`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          // const token = response.data.data.access_token;
          // const userId = response.data.userdto.userId;
          dispatch(actions.verifyOTPSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(actions.verifyOTPError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.verifyOTPError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.verifyOTPError(err));
              break;
            case 401:
              dispatch(actions.verifyOTPError("Unauthorized"));
              break;
            case 500:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.verifyOTPError(err));
              break;
            default:
              dispatch(actions.verifyOTPError("Unknown Error"));
              break;
          }
        } else {
          dispatch(actions.verifyOTPError("Internal Server Error"));
        }
      }),

  login: (props) => (dispatch) =>
    axios({
      method: "post",
      data: { emailId: props.emailID, otp: props.otp },
      headers: { "Content-Type": "application/json" },
      // url:
      //   `${Auth_OTP_URL}/verifyOTP?mobileNo=${props.emailID}&otp=${props.otp}&transactionId=27`,
      url: `${UserService_URL}/Apc_View/Amc_48/loginWithEmailOtpV2`,
    })
      .then((response) => {
        if (response.status === 200) {
          const token = response.data.token.access_token;
          const dpInfo    = response.data.dataPrincipalInfo || null;
          const nameAlias = dpInfo ? dpInfo.nameAlias : undefined;
          // Clear any stale inactivity popup flag from previous session
          localStorage.removeItem('inactivityPopup');
          dispatch(actions.loginSuccess(response, token, nameAlias, dpInfo));
          return response;
        } else {
          const error = new Error(response.statusText);

          dispatch(actions.loginError(error));
          throw error;
        }
      })
      .catch((originalErr) => {
        let err = originalErr;
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(actions.loginError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(actions.loginError(err));
              break;
            case 401:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(actions.loginError(err));
              break;
            case 500:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(actions.loginError(err));
              break;
            default:
              dispatch(actions.loginError("Unknown Error"));
              break;
          }
        } else {
          dispatch(actions.loginError("Internal Server Error"));
        }
        throw originalErr;
      }),

  checkAccessForExternalUser: (email) => (dispatch) =>
    axios({
      method: "post",
      data: { emailId: email },
      headers: { "Content-Type": "application/json" },
      url: `${Auth_OTP_URL}/Apc_View/Amc_49/checkAccessForExternalUser?portal=CONSENT`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  verifyEmailOTP: (email, otp) => (dispatch) =>
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${Auth_OTP_URL}/Apc_View/Amc_49/verifyOTP?mobileNo=${encodeURIComponent(email)}&otp=${otp}`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  setOrVerifyPin: (email, pin) => (dispatch) =>
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${Auth_OTP_URL}/Apc_Persist/Amc_49/setOrVerifyPin?identifier=${encodeURIComponent(email)}&pin=${pin}&portal=CONSENT`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  resetPin: (email, pin) => (dispatch) =>
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${Auth_OTP_URL}/Apc_Persist/Amc_49/setOrVerifyPin?identifier=${encodeURIComponent(email)}&pin=${pin}&reset=true&portal=CONSENT`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  generateCaptcha: () => (dispatch) =>
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${UserService_URL}/Apc_View/Amc_48/generateCaptcha`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  verifyCaptcha: (userInput, captchaImage, captchaUUID) => (dispatch) =>
    axios({
      method: "post",
      data: {
        captchaText: userInput,
        captchaImageBase64: captchaImage,
        uuid: captchaUUID,
      },
      headers: { "Content-Type": "application/json" },
      url: `${UserService_URL}/Apc_Persist/Amc_48/verifyCaptcha`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  saveDataPrincipalNameAlias: (identifier, nameAlias) => (dispatch) =>
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${ConsentManagementService_URL}/Apc_View/Amc_52/saveDataPrincipalNameAlias?identifier=${encodeURIComponent(identifier)}&nameAlias=${encodeURIComponent(nameAlias)}`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  getDataPrincipalInfoByDpId: (dpId, token) => (dispatch) =>
    axios({
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: `${ConsentManagementService_URL}/Apc_View/Amc_52/getDataPrincipalInfoByDpId?dpId=${encodeURIComponent(dpId)}`,
    })
      .then((response) => response)
      .catch((err) => { throw err; }),

  resetPass: (props) => (dispatch) =>
    axios({
      method: "post",
      data: props,
      headers: { "Content-Type": "application/json" },
      url: `${Auth_URL}/resetPassword?newPassword=` + props.newpass,
    })
      .then((response) => {
        if (response.status === 200) {
          const token = response.data.data.access_token;
          // const userId = response.data.userdto.userId;
          dispatch(actions.loginSuccess(response, token));
        } else {
          const error = new Error(response.statusText);
          dispatch(actions.loginError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.loginError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.loginError(err));
              break;
            case 401:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));
              dispatch(actions.loginError(err));
              break;
            case 500:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.loginError(err));
              break;
            default:
              dispatch(actions.loginError("Unknown Error"));
              break;
          }
        } else {
          dispatch(actions.loginError("Internal Server Error"));
        }
      }),

  ///////////////////////////////////////////////////////////
  setError() {
    return (dispatch) => dispatch(actions.setErrorRequest());
  },
  setErrorRequest() {
    return {
      type: actions.SET_ERROR,
    };
  },

  /////////////////////////////////////////////////////////////
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  // login: (credentials) => ({
  //   type: actions.LOGIN_REQUEST,
  //   payload: credentials
  // }),

  logoutFlagUpdate() {
    return {
      type: actions.LOGOUT_FLAG_UPDATE,
    };
  },

  // logout: () => ({
  //   type: actions.LOGOUT,
  // }),

  logoutPopup: () => ({
    type: actions.LOGOUT_POPUP,
  }),
};
export default actions;

export function logoutFlagUpdateData() {
  return (dispatch) => dispatch(actions.logoutFlagUpdate());
}

export function clearLogoutPopupData() {
  return (dispatch) => dispatch(actions.logoutPopup());
}

// get user details by id

export const UpdateUserDetailsActions = {
  SAVE_USER_DETAILS: "SAVE_USER_DETAILS",
  SAVE_USER_DETAILS_STATUS: "SAVE_USER_DETAILS_STATUS",
  SAVE_USER_DETAILS_FULFILLED: "SAVE_USER_DETAILS_FULFILLED",
  SAVE_USER_DETAILS_REJECTED: "SAVE_USER_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function updateUserDetails(params) {
  var imageId = 0;
  if (params.docId) {
    imageId = params.docId;
  } else {
    imageId = null;
  }
  var values = {
    currency: params.currency || null,
    firstName: params.userFirstName || null,
    language: params.language || null,
    lastName: params.userLastName || null,
    newPassword: params.newPassword || null,
    oldPassword: params.oldPassword || null,
    timeZone: params.timeZone || null,
    mobileNo: params.mobileNo || null,
    profileImage:
      params.base64 != null && params.fileName != null
        ? {
            base64: params.base64 || null,
            documentName: params.fileName || null,
            id: imageId,
          }
        : null,
  };
  return (dispatch) =>
    axios({
      method: "post",
      data: values,
      url: `${UserService_URL}/updateProfile`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(updateUserDetailsRequest());
        if (response) {
          if (response.status >= 200 && response.status < 300) {
            dispatch(updateUserDetailsSuccess(response));
            return response;
          } else {
            const error = new Error(response.statusText);
            dispatch(updateUserDetailsError(error));
            throw error;
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(updateUserDetailsError(err));
              break;
            case 401:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(updateUserDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(updateUserDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(updateUserDetailsError(err));
              break;
            case 500:
              dispatch(updateUserDetailsError("Server Error"));
              break;
            default:
              dispatch(updateUserDetailsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(updateUserDetailsError("Server Error"));
          // dispatch(logout());
        }
      });
}

export function updateUserDetailsRequest() {
  return {
    type: UpdateUserDetailsActions.SAVE_USER_DETAILS,
    isPosting: true,
  };
}
export function updateUserDetailsError(error) {
  return {
    type: UpdateUserDetailsActions.SAVE_USER_DETAILS_REJECTED,
    payload: error,
  };
}

export function updateUserDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: UpdateUserDetailsActions.SAVE_USER_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function updateUserDetailsStatus() {
  return (dispatch) => dispatch(updateUserDetailsStatusRequest());
}
export function updateUserDetailsStatusRequest() {
  return {
    type: UpdateUserDetailsActions.SAVE_USER_DETAILS_STATUS,
  };
}

export function setDetailsError() {
  return (dispatch) => dispatch(updateUserDetailsErrorRequest());
}
export function updateUserDetailsErrorRequest() {
  return {
    type: UpdateUserDetailsActions.SET_EDIT_ERROR,
  };
}

/////////////////CUSTOM_LOGOUT///////////////
export const customLogoutActions = {
  CUSTOM_LOGOUT: "CUSTOM_LOGOUT",
  CUSTOM_LOGOUT_SUCCESS: "CUSTOM_LOGOUT_SUCCESS",
  CUSTOM_LOGOUT_ERROR: "CUSTOM_LOGOUT_ERROR",
  LOGOUT_UNAUTHORIZED: "LOGOUT_UNAUTHORIZED",
};

export function customLogout(props) {
  //
  // let values = {
  //  access_token:props.access_token
  // };
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Auth_URL}/customLogout`,
      // headers: {
      //   Authorization: "Bearer " + props.access_token
      // }
      //data: values
    })
      .then((response) => {
        dispatch(customLogoutRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(customLogoutSuccess(response));
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(customLogoutError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(customLogoutError(err));
              break;
            case 401:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(actions.logout());
              break;
            case 403:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(customLogoutError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(customLogoutError(err));
              break;
            case 500:
              dispatch(customLogoutError("Server Error"));
              break;
            default:
              dispatch(customLogoutError("Unknown Error"));
              break;
          }
        } else if (!err.response) {
          dispatch(customLogoutError("Internal Server Error!"));
        } else {
          dispatch(actions.logout());
        }
      });
}
// export function logoutOnUnauthorized(props) {
//   return dispatch => {
//     dispatch({
//       type: customLogoutActions.LOGOUT_UNAUTHORIZED,
//       payload: props
//     });
//   };
// }

export function customLogoutSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: customLogoutActions.CUSTOM_LOGOUT_SUCCESS,
      payload: props,
    });
  };
}
export function customLogoutRequest() {
  return {
    type: customLogoutActions.CUSTOM_LOGOUT,
    isPosting: true,
  };
}
export function customLogoutError(error) {
  return {
    type: customLogoutActions.CUSTOM_LOGOUT_ERROR,
    payload: error,
  };
}
